let domain = "https://qlearnapi.medlearnity.com";

const storedValue = JSON.parse(window.localStorage.getItem('emailLogin'));

if (storedValue === undefined) {
    window.localStorage.setItem('emailLogin', false);
}

let isProdEnv = storedValue !== undefined ? !storedValue : true;

if (window.location.hostname === 'devqlearn.medlearnity.com' || window.location.hostname === 'localhost') {
    domain = "https://devqlearnapi.medlearnity.com";
    isProdEnv = false;
} else if (window.location.hostname === 'preprodqlearn.medlearnity.com') {
    domain = "https://preprodqlearnapi.medlearnity.com";
    isProdEnv = false;
}

// Bundled mobile builds serve from capacitor://localhost, so hostname-based
// selection above would always pick the dev API. The Capacitor build script
// (mobile/qlearn-absite/scripts/build-web.mjs) bakes the intended target in via
// REACT_APP_QLEARN_API_BASE_URL — an explicit override that wins over hostname
// detection. Trailing slash trimmed so `${domain}/qlearn/...` composes cleanly.
const apiBaseUrlOverride = process.env.REACT_APP_QLEARN_API_BASE_URL;

if (typeof apiBaseUrlOverride === 'string' && apiBaseUrlOverride.trim() !== '') {
    domain = apiBaseUrlOverride.trim().replace(/\/+$/, '');
    isProdEnv = domain === "https://qlearnapi.medlearnity.com";
}

export const isProd = isProdEnv;

const urls = {
    domain,
    addUser: `${domain}/qlearn/auth/signup`,
    login: `${domain}/qlearn/auth/signin`,
    verifyAccount: `${domain}/qlearn/auth/verify-account/`,
    forgetPwd: `${domain}/qlearn/auth/forget-password/`,
    changePwd: `${domain}/qlearn/auth/change-password/`,
    userDetails: `${domain}/qlearn/user/`,
    userDetailsFromToken: `${domain}/qlearn/user/me`,
    // Runtime client config (in-quiz egress C0; QLearn-service PR #489)
    clientConfig: `${domain}/qlearn/client-config`,
    questionsList: `${domain}/qlearn/user/`,
    submitQuiz: `${domain}/qlearn/quiz`,
    createQuiz: `${domain}/qlearn/api/v2/quiz`,
    diagnostic: `${domain}/qlearn/diagnostic`,
    startAbsiteDiagnostic: `${domain}/qlearn/diagnostic/absite/start`,
    absiteProgramSummary: `${domain}/qlearn/diagnostic/absite/program-summary`,
    absiteProgramCodes: `${domain}/qlearn/diagnostic/absite/program-codes`,
    absiteProgramCodeRequest: `${domain}/qlearn/diagnostic/absite/program-codes/request`,
    // Generic ReviewQueue (new /qlearn/review/* endpoints; flag-gated, 404 while dark).
    reviewQueue: `${domain}/qlearn/review`,
    // Content-quality analytics (read-only /qlearn/content-quality/*; flag-gated, 404 while dark).
    contentQuality: `${domain}/qlearn/content-quality`,
    notesToQuiz: `${domain}/qlearn/notes-to-quiz`,
    categories: `${domain}/qlearn/quiz/categories`,
    questionCategories: `${domain}/qlearn/bank/question/category`,
    getQuiz: `${domain}/qlearn/quiz/`,
    quizHistory: `${domain}/qlearn/quiz-history/quiz/`,
    questionHistory: `${domain}/qlearn/question-history/quiz/`,
    studentQuizHistory: `${domain}/qlearn/quiz-history/user/`,
    overallStudentQuiz: `${domain}/qlearn/quiz/user`,
    overallQuizHistory: `${domain}/qlearn/user-performance/user/`,
    questionMetadata: `${domain}/qlearn/bank/question`,
    reviewQuestion: `${domain}/qlearn/question-history`,
    packageList: `${domain}/qlearn/package/status/ACTIVE`,
    paymentSession: `${domain}/qlearn/booking/create-payment-session`,
    booking: `${domain}/qlearn/booking`,
    userActivity: `${domain}/qlearn/useractivity/user/`,
    userPayments: `${domain}/qlearn/booking/user/`,
    cancelSubscription: 'cancel-subscription',
    invitation: `${domain}/qlearn/enrollments/invitations`,
    preference: `${domain}/qlearn/user/preference`,
    comment: `${domain}/qlearn/bank/question`,
    feedback: `${domain}/qlearn/user/feedback`,
    image: `${domain}/qlearn/bank/image`,
    quesFeedback: `${domain}/qlearn/question/feedback/student`,
    quesCatCount: `${domain}/qlearn/quiz/categories/questions`,
    quesTutorFeedback: `${domain}/qlearn/question/feedback/tutor`,
    tutorFeedbackAll: `${domain}/qlearn/question/feedback/tutor/all`,
    studentFeedbackAll: `${domain}/qlearn/question/feedback/student/all`,
    feedbackBlock: `${domain}/qlearn/quiz/block`,
    packagePlan: `${domain}/qlearn/plan`,
    sendInvites: `${domain}/qlearn/enrollments/invitations`,
    getUsersByRole: `${domain}/qlearn/users`,
    categoryPreference: `${domain}/qlearn/quiz/categories/preferences/selected/user/`,
    topicsSearch: `${domain}/qlearn/medical-categorization/categories/v2/search?keyword=`,
    fetchQlink: `${domain}/qlearn/qlink`,
    publishQlink: `${domain}/qlearn/qlink/publish`,
    revokeQlink: `${domain}/qlearn/qlink/revoke/`,
    qlinkQuestionAnswered: `${domain}/qlearn/qlink/events/question-answered`,
    qlinkQues: `${domain}/qlearn/qlink/questions`,
    sendOTP: `${domain}/qlearn/auth/phone/send-otp`,
    verifyOTP: `${domain}/qlearn/auth/phone/verify-otp`,
    // Native Sign in with Apple: backend verifies the identityToken against
    // Apple's JWKS (Step-1 native-auth infra; consumed by the trio UI in Step 2).
    appleAuth: `${domain}/qlearn/auth/apple`,
    completeProfile: `${domain}/qlearn/profile/complete`,
    referralCode: `${domain}/qlearn/api/referral/code`,
    referralStats: `${domain}/qlearn/api/referral/stats`,
    powerSearch: `${domain}/qlearn/quiz/power-search`,
    mentorships: `${domain}/qlearn/mentorships`,
    mentorshipTags: `${domain}/qlearn/mentorships/tags`,
    // Live polling session (Q7-T1, dark — the server 404s every route until
    // qlearn.live-session.enabled). Gateway prefix /qlearn like qlink/mentorships.
    liveSession: `${domain}/qlearn/live-session`,
    // Zoom-watermark id-book store (PUT upsert; the decoder GETs the same
    // path by eventId). See utils/session-fiducial/id-book-emitter.js.
    sessionFiducialIdBook: `${domain}/qlearn/session-fiducial/id-book`,
    // Guided Learning (GL-1 §1/§3) client callers, per the server-owned wire
    // contract (docs/gl-api-wire-contract.md, QLearn-service). glHint never
    // carries WHY; glEvent posts an allowlisted, userIdHash-keyed record (the
    // server re-redacts + overrides the subject key). glWhy/glAssisted were
    // REMOVED (ROW1 gate B4/B5 cure): the student's reasoning rides ONLY the
    // card-draft call at grade time, and "assisted" is recorded server-side at
    // hint-serve. Dark until the GL flag + server audience are on.
    glHint: `${domain}/qlearn/gl/hint`,
    glEvent: `${domain}/qlearn/gl/event`,
    // Backend experiment-exposure sink (exposure-sink ruling 2026-07-18; dark
    // flag-gated on BOTH ends — see utils/experiments.js trackExperimentExposure).
    experimentExposure: `${domain}/qlearn/experiment/exposure`
}

export default urls;
